module.exports = __webpack_public_path__ + "img/talmid_yes.08d71bfd.png";